module.exports = __webpack_public_path__ + "img/ditto-tier-logo-gray.3c512e1f.png";